export const stanzas = [
  {
    id: "decisions",
    lines: ["Most engineers write code.", "I write decisions."],
  },
  {
    id: "ai",
    lines: [
      "AI isn't replacing me.",
      "I decide how it gets used.",
      "That distinction is everything.",
    ],
  },
  {
    id: "endtoend",
    lines: [
      "I think end-to-end —",
      "from the first click",
      "to what breaks at 2am.",
    ],
  },
  {
    id: "systems",
    lines: [
      "I don't build features.",
      "I build systems that understand",
      "why the feature exists.",
    ],
  },
  {
    id: "dx",
    lines: [
      "I obsess over developer experience.",
      "Building tools I'd want to use",
      "exhausted and shipping.",
    ],
  },
];
